import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
//import { parseRawData } from '../../parsers';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import _ from 'lodash';
import { getSalesAttribute } from 'gqlQueries/growthAnalysisQueries';
import { salesAttributeDataParser } from 'parser/salesAttributionDataParser';

const errorMessage: string = 'Something went wrong!';

function useFetchSalesAttribute() {
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);
    const [extraData, setExtraData] = useState<any | null>(null);

    const [
        fetchAttributeSales,
        { data: attributeSalesData, loading: attributeSalesLoading, error: attributeSalesError },
    ] = useLazyQuery(getSalesAttribute, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    useEffect(() => {
        if (attributeSalesLoading) setLoading(attributeSalesLoading); //only change loading to false inside oncomplete function
    }, [attributeSalesLoading]);

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getSalesAttributionFeatureGroupLevel: featureGroup } = payload;
            //const featureGroup = payload;
            //if data present parse it
            if (featureGroup && 'featureGroupLevelData' in featureGroup) {
                const parsedData = salesAttributeDataParser(featureGroup?.featureGroupLevelData);
                setData(parsedData?.data);
                setExtraData(parsedData?.extra);
                return;
            }
            setData([]);
        } catch (error) {
            console.error(errorMessage, error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        //sending empty data to error to avoid null data being sent
        setData([]);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        extra: extraData,
        fetchAttributeSales: (variables: any) => {
            setData(null);
            setExtraData(null);
            //onFetchComplete(dummyData);
            fetchAttributeSales(variables);
        },
    };
}

export { useFetchSalesAttribute };
